import { QuestionnaireAnswerType } from 'components/Assessments/types'
import { MedicationsQuestionnaireItem } from './questionnaire'

export const MEDICATIONS_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE = {
  [MedicationsQuestionnaireItem.MEDICATIONS_MEDICATION_LIST_MEDICATION_INFO_DRUGBANK_PCID]:
    QuestionnaireAnswerType.STRING,
  [MedicationsQuestionnaireItem.MEDICATIONS_MEDICATION_LIST_MEDICATION_INFO]:
    QuestionnaireAnswerType.GROUP,
  [MedicationsQuestionnaireItem.MEDICATIONS_MEDICATION_LIST_MEDICATION_INFO_NAME]:
    QuestionnaireAnswerType.STRING,
  [MedicationsQuestionnaireItem.MEDICATIONS_MEDICATION_LIST_MEDICATION_INFO_ROUTE]:
    QuestionnaireAnswerType.STRING,
  [MedicationsQuestionnaireItem.MEDICATIONS_MEDICATION_LIST_MEDICATION_INFO_STRENGTH_NUMBER]:
    QuestionnaireAnswerType.DECIMAL,
  [MedicationsQuestionnaireItem.MEDICATIONS_MEDICATION_LIST_MEDICATION_INFO_STRENGTH_UNIT]:
    QuestionnaireAnswerType.STRING,
  [MedicationsQuestionnaireItem.MEDICATIONS_MEDICATION_LIST_MEDICATION_INFO_INDICATIONS]:
    QuestionnaireAnswerType.STRING,
  [MedicationsQuestionnaireItem.MEDICATIONS_MEDICATION_LIST_MEDICATION_INFO_FREQUENCY]:
    QuestionnaireAnswerType.STRING,
  [MedicationsQuestionnaireItem.MEDICATIONS_MEDICATION_LIST_MEDICATION_INFO_DOSAGE_NUMBER]:
    QuestionnaireAnswerType.DECIMAL,
  [MedicationsQuestionnaireItem.MEDICATIONS_MEDICATION_LIST_MEDICATION_INFO_DOSAGE_UNIT]:
    QuestionnaireAnswerType.STRING,
  [MedicationsQuestionnaireItem.MEDICATIONS_MEDICATION_LIST_MEDICATION_INFO_INSTRUCTIONS]:
    QuestionnaireAnswerType.STRING,
  [MedicationsQuestionnaireItem.MEDICATIONS_MEDICATION_LIST_MEDICATION_INFO_USAGE_STATUS]:
    QuestionnaireAnswerType.STRING,
  [MedicationsQuestionnaireItem.MEDICATIONS_MEDICATION_LIST_MEDICATION_INFO_START_DATE]:
    QuestionnaireAnswerType.DATE,
  [MedicationsQuestionnaireItem.MEDICATIONS_MEDICATION_LIST_MEDICATION_INFO_DISCONTINUE_DATE]:
    QuestionnaireAnswerType.DATE,
  [MedicationsQuestionnaireItem.MEDICATIONS_MEDICATION_LIST_MEDICATION_INFO_CONTROLLED]:
    QuestionnaireAnswerType.BOOLEAN,
  [MedicationsQuestionnaireItem.MEDICATIONS_MEDICATION_LIST_MEDICATION_INFO_LIQUID]:
    QuestionnaireAnswerType.BOOLEAN,
  [MedicationsQuestionnaireItem.MEDICATIONS_MEDICATION_LIST_MEDICATION_INFO_INFECTION]:
    QuestionnaireAnswerType.BOOLEAN,
  [MedicationsQuestionnaireItem.MEDICATIONS_MEDICATION_SUMMARY]: QuestionnaireAnswerType.STRING
}
